// One way to print a Sales number. Unknown (null / undefined / "") is "—", never
// $0 or 0; a real 0 the backend sent stays 0. Money keeps its cents: a rep's pay
// is never rounded on screen. Nothing here adds, subtracts or derives a pay
// number — commission figures are printed exactly as the backend computed them.
const isBlank = (v) => v === null || v === undefined || v === "";
const num = (v) => (isBlank(v) ? null : Number.isFinite(Number(v)) ? Number(v) : null);

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const money = (v) => { const n = num(v); return n === null ? "—" : usd.format(n); };
export const count = (v) => { const n = num(v); return n === null ? "—" : n.toLocaleString("en-US"); };
/** A percentage the backend sent as a number of percent (e.g. 12.5 → "12.5%"). */
export const pct = (v) => { const n = num(v); return n === null ? "—" : `${n.toLocaleString("en-US", { maximumFractionDigits: 1 })}%`; };
/** A rate the backend sent as a fraction (0.2 → "20%"). Display only. */
export const rate = (v) => { const n = num(v); return n === null ? "—" : `${(n * 100).toLocaleString("en-US", { maximumFractionDigits: 2 })}%`; };
export const shortDate = (v) => {
  if (isBlank(v)) return "—";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(String(v)) ? new Date(`${v}T00:00:00`) : new Date(v);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
export const words = (v) => (isBlank(v) ? "—" : String(v).replace(/_/g, " "));
export const sentence = (v) => { const s = words(v); return s === "—" ? s : s.charAt(0).toUpperCase() + s.slice(1); };
